// 添加 helper 逻辑
// 1. 在 globalModalHelper.ts 中添加 helperImg
// 2. zh-CN.ts 和 en-US.ts 中添加 helper 的翻译 title 和数组

export const helperImg: Record<HelperModalType, string[]> = {
  earn: [
    "https://www.any-mate.com/images/drawing-202408-12-245239c5-d47c-412c-bb61-67f5051f6c2b.png/raw",
    "https://www.any-mate.com/images/drawing-202408-12-d276fb6a-bc58-4969-bdf2-f8e309ca469d.png/raw",
    "https://www.any-mate.com/images/drawing-202408-12-9ba42c4f-7d10-4242-bb4c-14328657cdff.png/raw",
  ],
};
